import { FunctionComponent, ReactNode } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";

interface IStyledModalComponent {
    children?: ReactNode
    show?: boolean
    width?: string;
    onHide?: (e: any) => void
    backdrop?: boolean | "static"
    className?: string
    /**
     * Both default to react-bootstrap's own (on). Turned off only by a dialog that
     * hands focus back to what is behind it while it is still closing — see
     * LinkUrlDialog — where the enforcement would pull focus straight back.
     */
    enforceFocus?: boolean
    restoreFocus?: boolean
}

const StyledModal: FunctionComponent<IStyledModalComponent> = ({
    children,
    show,
    width = "448px",
    onHide,
    backdrop = "static",
    className,
    enforceFocus,
    restoreFocus,
}) => {
    return (
        <StyledModalComponent
            className={className}
            show={show}
            onHide={onHide}
            backdrop={backdrop}
            width={width}
            enforceFocus={enforceFocus}
            restoreFocus={restoreFocus}
        >
            {children}
        </StyledModalComponent>
    )
}

const StyledModalComponent = styled(Modal)<{ width: string }>`  
    z-index: 10000002;
    background-color: #0000004d;
    
    & .modal-dialog {
        width: ${({ width }) => width};
        max-width: none;
        position: relative;
        top: 70px;  
    }
    
    & .modal-content {
        width: ${({ width }) => width};
        max-width: none;
    }
`

export default StyledModal